import getArrayBufferFromFile from 'app/shared/utils/getArrayBufferFromFile';
import getTextFromFile from 'app/shared/utils/getTextFromFile';
import fileType from 'file-type';
import isSvg from 'is-svg';

const getContentTypeFromFile = async (file: File) => {
  try {
    const text = await getTextFromFile(file);

    if (isSvg(text)) {
      return 'image/svg+xml';
    }

    const arrayBuffer = await getArrayBufferFromFile(file);
    const result = fileType(new Uint8Array(arrayBuffer));

    if (result) {
      return result.mime;
    }

    return file.type;
  } catch (error) {
    throw error;
  }
};

export default getContentTypeFromFile;
